import {
  Fab,
  Grid,
  Link,  
  Switch,
  Table,
  Tooltip
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import React, { useState, FunctionComponent } from "react";
import MUIDataTable from "mui-datatables";
import { useUsersStyles } from "../../useUsersStyles";
import { useStore } from "../../../../store";
import { useTableStyles } from "../../../useTableStyle";
import moment from "moment";
import { SnackBar } from "../../../SnackBar";
import { ConfirmationDailog } from "../../ConfirmationDialog";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "FIRST NAME",
  "ROLE",
  "STATUS",
  "ACTIVE TERMINAL",
  "LAST ACTIVE",
  "",
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

type userParams = {
  storeList: string;
  goToEdit: (id: number) => void;
  handleResetPassword: (id: number) => void;
  editPosPermissionFlag: boolean;
};
export const PosUserList: FunctionComponent<userParams> = ({
  storeList,
  goToEdit,
  handleResetPassword,
  editPosPermissionFlag
}) => {
  const classes = useUsersStyles();
  const getMuiTheme = useTableStyles();
  const [posUsers, { getPosUsers, updatePOSUser }] = useStore("posUsers");
  const [status] = useStore("status");
  const [UserObject, setUserObject] = useState<any>();
  const [statusInfo, setStatusInfo] = useState<string>("");
  const [confirmationDialog, setConfirmationDialog] = useState<boolean>(false);
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");

  const handleEditClick = (id: number) => {
    goToEdit(id);
  };

  const confirmationDialogClose = () => {
    setConfirmationDialog(false);
    setSnackbarColor("green");
    setStatusInfo("Status updated successfully");
  };
  const UserDetails = (id: number) => {
    const posUserData =
    posUsers && posUsers.find((user: any) => user.id === id);
    setUserObject(posUserData);
  };

  const onCloseSnackbar = () => {
    setStatusInfo("");
  };

  const onStatusUpdation = async (values: any, userType: string, status: any) => {
    try {
      const status_desc_inactive = status.find((value: any) => value.description === "Inactive")
      const status_desc_active = status.find((value: any) => value.description === "Active")
        const POSUserUpdateData = {
          status: values.status_description === "Active" ? status_desc_inactive.id : status_desc_active.id
        };
        await updatePOSUser(UserObject.id, POSUserUpdateData);
        await getPosUsers();
        confirmationDialogClose();
    } catch (error) {
      console.log(error);
    }
  };

  if (posUsers && posUsers.length > 0) {
    return (
      <div>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Pos Users List"}
              data={posUsers.map((item: any) => {
                return [
                  item.full_name,
                  item.type_of_user !== null ? (
                    item.type_of_user
                  ) : ("-"),
                  item.status_description,
                  item.islogin === true ? item.active_terminal : "-",
                  item.last_login !== null ? moment(item.last_login).fromNow() : "Never logged in",
                  <Grid container direction="row">
                    <Grid item>
                      <Tooltip title="Edit">
                        <Fab
                          size="small"
                          aria-label="edit"
                          color="secondary"
                          style={{ display: editPosPermissionFlag ? "none" : "",boxShadow:"none" }}
                          className={classes.editIconMargin}
                          onClick={() => handleEditClick(item.id)}
                        >
                          <EditIcon className={classes.editIcon} />
                        </Fab>
                      </Tooltip>
                    </Grid>
                    <Grid item style={{ display: editPosPermissionFlag ? "none" : "" }}>
                      <Tooltip
                        title={
                          item.status_description === "Active"
                            ? "Change Status to Inactive"
                            : "Change Status to Active"
                        }
                      >
                        <Switch
                          checked={item.status_description === "Active" ? true : false}
                          onChange={() => {
                            UserDetails(item.id);
                            setConfirmationDialog(true);
                          }}
                          style={{color:item.status_description === "Active"?"#3d5a79": undefined}}
                          color="primary"
                          name="status"
                          inputProps={{ "aria-label": "primary checkbox" }}
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={6} className={classes.resetPasswordPosition}>
                      <Link
                        style={{
                          display: editPosPermissionFlag ? "none" : "",
                          color: "black",
                          cursor:"pointer"                          
                        }}
                        onClick={() => handleResetPassword(item.id)}
                      >
                        Change Password
                     </Link>
                    </Grid>
                  </Grid>
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        {confirmationDialog ? (
          <ConfirmationDailog
            userType={storeList}
            UserObject={UserObject}
            ConfirmationDailogClose={confirmationDialogClose}
            status={status}
            onStatusUpdation={onStatusUpdation}
          />
        ) : null}
        <SnackBar
          status={statusInfo}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Pos Users List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
